import { FeatureStyle } from "../featuretree/internal";
import { USERINPUTTYPE } from "../internal";
import { Layer, LAYERTYPE } from "./internal";
import { distinctUntilChanged, filter, map } from "rxjs/operators";
export const DEFAULTNETWORKSTYLE = new FeatureStyle({
    stylename: "layerstyle",
    rules: [
        {
            filter: "",
            symbolizer: "point",
            params: {
                size: 5,
                stroke: [1, 0.5, 0, 0.8],
            },
        },
        {
            filter: "",
            symbolizer: "line",
            params: {
                "stroke-width": 1,
                stroke: [0.1, 0.8, 0.4, 1],
            },
        },
    ],
});
/**
 * Extension of the Layer-Class for Layers
 * @class Infra3DLayer
 */
export class NetworkLayer extends Layer {
    constructor(scene, opt_options) {
        super(scene, opt_options);
        this._axiscollection = [];
        this._geoframechangedevt = -1;
        this.axisformat = "{axisid} u={u:number('0.00')*0.001}km";
        this.type = LAYERTYPE.NETWORKLAYER;
        const options = opt_options || {};
        this.axisloader = options.axisloader;
        this._axisidattributearray = options.axisidattributearray || [];
        this._nominallengthattribute = options.nominallengthattribute || "nominallength";
        this._offsetattribute = options.offsetattribute || "offset";
        this._axisnameattribute = options.axisnameattribute || "name";
        this._axistypeattribute = options.axistypeattribute || "type";
        this.visible = typeof options.visible === "undefined" ? false : options.visible;
        this.axisformat = options.axisformat || "{axisid} u={u:number('0.00')*0.001}km";
        this._nonavigationtypes = options.nonavigationtypes || ["Gleisachse"];
        this._alignsettings = options.alignsettings || {
            v_tolerance_realign: 15,
            u_border_tolerance_realign: 5,
            v_clip_onaxis: 10,
            v_clip_outofaxis: 12,
            n_frame_samples: 8,
            v_tolerance_initial: 50,
        };
        if (typeof options.style == "object" && !(options.style instanceof FeatureStyle)) {
            options.style = new FeatureStyle(options.style);
        }
        this.setOptions({
            style: options.style || DEFAULTNETWORKSTYLE,
        });
        this._geoframechangedevt = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, (geoframe) => {
            if (this.scene.getLRHandler().getActiveNavigationAxis() === null) {
                this._setclosestactive(geoframe);
            }
        }, this);
        const stopon_navigation_axischanged = options.stoponaxischanged || false;
        if (stopon_navigation_axischanged) {
            this._navigationaxischangedsubscription = this.scene.userinputapi.navigationaxischanged$
                .pipe(filter((axis) => {
                if (axis)
                    return true;
            }), filter((axis) => {
                if (axis.axis)
                    return true;
            }), filter((axis) => {
                if (axis.axis.features.length > 0)
                    return true;
            }), map((axis) => axis.axis.features[0].properties[this._axisnameattribute]), distinctUntilChanged())
                .subscribe((axis) => {
                if (this.scene.navigator.playService.playing && axis) {
                    this.scene.navigator.playService.stop();
                }
            });
        }
    }
    /**
     *
     * by a given function 'loadFeatures' in the options.
     * @param extent
     * @param srid
     */
    _loadFeatures_internal(extent, srid) {
        this.scene.getLRHandler().reloadingAxis = true;
        if (this.onlayerupdated) {
            this.onlayerupdated(this, {
                reload: true,
            });
        }
        for (const axis of this._axiscollection) {
            this.scene.getLRHandler().removeAxis(axis.axis);
        }
        this._axiscollection = [];
        this.axisloader.loadaxis(extent, srid, (sectors) => {
            const layerfc = {
                type: "FeatureCollection",
                features: [],
            };
            for (const axisfc of sectors.value) {
                let fc = axisfc.value;
                let axisname = "";
                let axistype = "";
                for (const feature of fc.features) {
                    axisname = feature.properties[this._axisnameattribute] || feature.id;
                    axistype = feature.properties[this._axistypeattribute] || "";
                    layerfc.features.push(feature);
                }
                fc = JSON.parse(JSON.stringify(fc));
                const axis = this.scene
                    .getLRHandler()
                    .createAxis(fc, this._nominallengthattribute, this._offsetattribute, this._axisidattributearray, axisname);
                if (this._nonavigationtypes.indexOf(axistype) > -1) {
                    axis.isnavigationref = false;
                }
                this._axiscollection.push({
                    axis: axis,
                    name: axisname,
                    type: axistype,
                });
            }
            // Called before setting the new active axis
            this.scene.getLRHandler().reloadingAxis = false;
            this._setclosestactive(this.scene.getCurrentGeoframe());
            this.addFeatures(layerfc);
        });
    }
    _setclosestactive(geoframe) {
        const axis = this.scene.getLRHandler().getActiveNavigationAxis();
        if (axis) {
            const uvw = axis.xyz2uvw(geoframe.easting, geoframe.northing, geoframe.height);
            if (uvw) {
                const coords = axis.axis.features[uvw.featureidx].geometry.coordinates;
                let axislen = axis.k[uvw.featureidx][1];
                for (let j = 0; j < coords.length - 1; j++) {
                    axislen += Math.sqrt(Math.pow(coords[j + 1][0] - coords[j][0], 2) + Math.pow(coords[j + 1][1] - coords[j][1], 2));
                }
                // Checks, if the active axis is not good anymore -> If its ok, it returns without setting a new acitve axis.
                if (uvw.lrcoords[0] > this._alignsettings.u_border_tolerance_realign &&
                    uvw.lrcoords[0] < axislen - this._alignsettings.u_border_tolerance_realign &&
                    uvw.lrcoords[1] < this._alignsettings.v_tolerance_realign &&
                    uvw.lrcoords[1] > -this._alignsettings.v_tolerance_realign) {
                    return;
                }
            }
        }
        if (this._axiscollection.length == 0)
            return;
        const axiscollection = this._axiscollection.filter((obj) => obj.axis.isnavigationref);
        let geoframearray = this.scene.getCurrentGeoFrameCollection().geoframearray;
        const geoframes_amount = 100;
        if (geoframearray.length > geoframes_amount) {
            const current_geoframeindex = geoframearray.findIndex((element) => element.getFramenumber() == geoframe.getFramenumber());
            if (current_geoframeindex < geoframes_amount / 2) {
                geoframearray = geoframearray.slice(0, current_geoframeindex + geoframes_amount / 2);
            }
            else if (current_geoframeindex > geoframearray.length - geoframes_amount / 2) {
                geoframearray = geoframearray.slice(current_geoframeindex - geoframes_amount / 2, geoframearray.length);
            }
            else {
                geoframearray = geoframearray.slice(current_geoframeindex - geoframes_amount / 2, current_geoframeindex + geoframes_amount / 2);
            }
        }
        const _fchecklength = geoframearray.length / this._alignsettings.n_frame_samples;
        let vsum = 6.0; //Initial sum of v-coordinates. If none of the rows falls below this value, no
        // row will be selected as active.
        let closest_axis = -1;
        for (let j = 0; j < axiscollection.length; j++) {
            // let csum = 0.0;
            const v_array = [];
            //Calculates the sum of all v-coordinates of sample points extracted from the stream.
            for (let i = 0; i < this._alignsettings.n_frame_samples; i++) {
                const fnumber = Math.floor(i * _fchecklength);
                const lr = axiscollection[j].axis.xyz2uvw(geoframearray[fnumber].easting, geoframearray[fnumber].northing, geoframearray[fnumber].height);
                if (lr) {
                    if (Math.abs(lr.lrcoords[1]) < this._alignsettings.v_clip_onaxis) {
                        v_array.push(Math.abs(lr.lrcoords[1]));
                    }
                    else {
                        v_array.push(this._alignsettings.v_clip_onaxis);
                    }
                }
                else {
                    v_array.push(this._alignsettings.v_clip_onaxis * 1.2);
                }
            }
            //TODO: Algorithm here to be discussed.
            if (v_array.length > 1) {
                const mean_distance = v_array.reduce((previous, current) => (current += previous)) / v_array.length;
                const mean_distance_weighted = mean_distance / this._alignsettings.v_clip_onaxis;
                const csum = mean_distance_weighted;
                if (csum > 0.0 && csum < 1.2)
                    if (csum < vsum) {
                        vsum = csum;
                        closest_axis = j;
                    }
            }
        }
        if (closest_axis !== -1) {
            const uvw = axiscollection[closest_axis].axis.xyz2uvw(geoframe.easting, geoframe.northing, geoframe.height);
            if (!uvw) {
                this.scene.getLRHandler().setActiveNavigationAxis(null);
                return;
            }
            if (Math.abs(uvw.lrcoords[1]) > this._alignsettings.v_tolerance_initial) {
                this.scene.getLRHandler().setActiveNavigationAxis(null);
                return;
            }
            this.scene.getLRHandler().setActiveNavigationAxis(axiscollection[closest_axis].axis);
        }
        else {
            this.scene.getLRHandler().setActiveNavigationAxis(null);
        }
    }
    getAxisCollection() {
        return this._axiscollection;
    }
    getFormattedAxisid(props, u) {
        let axisid = "";
        for (const axisidattribute of this._axisidattributearray) {
            axisid += props[axisidattribute] + " ";
        }
        return axisid.slice(0, -1);
    }
    destroy() {
        for (const axis of this._axiscollection) {
            this.scene.getLRHandler().removeAxis(axis.axis);
        }
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, this._geoframechangedevt);
        if (this._navigationaxischangedsubscription)
            this._navigationaxischangedsubscription.unsubscribe();
        this.axisloader.destroy();
        super.destroy();
    }
    _getAxisnameFromAxis(axis) {
        let axisname = "";
        for (const axisobject of this._axiscollection) {
            if (axisobject.axis === axis) {
                axisname = axisobject.name;
                break;
            }
        }
        return axisname;
    }
    addAxisToSelection(axis) {
        const axisname = this._getAxisnameFromAxis(axis);
        if (axisname != "") {
            for (const feature of this.featurecollection.features) {
                if (this.getAxisnameFromFeature(feature) == axisname) {
                    this.featureselector.addToSelection(feature.id);
                }
            }
        }
    }
    removeAxisFromSelection(axis) {
        const axisname = this._getAxisnameFromAxis(axis);
        if (axisname != "") {
            for (const feature of this.featurecollection.features) {
                if (this.getAxisnameFromFeature(feature) == axisname) {
                    this.featureselector.removeFromSelection(feature.id);
                }
            }
        }
    }
    /**
     * Highlights all features of the given axis without selecting them.
     * @param axis The axis to highlight.
     */
    axisHighlightOn(axis) {
        const axisname = this._getAxisnameFromAxis(axis);
        if (axisname != "") {
            for (const feature of this.featurecollection.features) {
                if (this.getAxisnameFromFeature(feature) == axisname) {
                    feature.highlightOn();
                }
            }
        }
    }
    /**
     * Un-Highlights all features of the given axis without selecting them.
     * @param axis The axis to un-highlight.
     */
    axisHighlightOff(axis) {
        const axisname = this._getAxisnameFromAxis(axis);
        if (axisname != "") {
            for (const feature of this.featurecollection.features) {
                if (this.getAxisnameFromFeature(feature) == axisname) {
                    feature.highlightOff();
                }
            }
        }
    }
    setAxisVisible(axis, visibility) {
        const axisname = this._getAxisnameFromAxis(axis);
        if (axisname == "")
            return;
        for (const feature of this.featurecollection.features) {
            if (this.getAxisnameFromFeature(feature) == axisname) {
                if (visibility) {
                    feature.show();
                }
                else {
                    feature.hide();
                }
            }
        }
        this.scene.infrascene.render();
    }
    getAxisnameFromFeature(feature) {
        return feature.properties[this._axisnameattribute];
    }
}
//# sourceMappingURL=networklayer.js.map